import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './recording-list.css';
import RecordingItem from './RecordingItem';

const RecordingList = ({ recordingList, jwt, isPosterImgPortrait, mode, poster, eventId }) => {
  const urlObj = new URL(window.location.href);
  const [reclist, setReclist] = useState([]);

  useEffect(() => {
    if (recordingList.length === 0) return;
    const items = [...recordingList];
    //sort recording list on the basis of start time (in increasing order)
    if (items.length === 1) {
      setReclist(items);
      return;
    }
    items.sort(function (a, b) {
      if (a.StartTime > b.StartTime) return 1;
      if (a.StartTime < b.StartTime) return -1;
      return 0;
    });
    setReclist(items);
  }, [recordingList]);

  const getRecordingLink = (item) => {
    const origin = urlObj.origin;
    const url = `${origin}/#id=${item.ID}&jwt=${jwt}${item.ID === eventId ? '&dvr=true' : ''}`;
    return url;
  };

  return (
    <>
      {reclist.length > 0 ? (
        <div className="recList">
          {[...reclist].map((item, i) => {
            return (
              <RecordingItem
                key={item.ID}
                href={getRecordingLink(item)}
                duration={item.Duration}
                recordingId={item.ID}
                recCount={reclist.length}
                idx={i}
                isPosterImgPortrait={isPosterImgPortrait}
                mode={mode}
                poster={poster}
              />
            );
          })}
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  recordingList: state.app.recordingList,
  eventId: state.app.eventId,
  jwt: state.app.config.jwt,
  mode: state.app.mode,
  poster: state.app.poster,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RecordingList);
